module.exports = __webpack_public_path__ + "img/0Q3B1666_L_WoodMatted_MockedUp.f60af842.jpg";